import { useState, type FormEvent } from 'react';
import { useApi } from '../hooks/useApi';
import type { User } from '../types';
import AdminDialog from './AdminDialog';

export default function CreateUserModal({ onClose, onCreated }: { onClose: () => void; onCreated: () => void }) {
  const { createUser } = useApi();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [permissions, setPermissions] = useState(['search', 'metadata', 'health', 'export', 'contacts', 'suggestions']);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [created, setCreated] = useState<User | null>(null);
  const submit = async (event: FormEvent) => {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const user = await createUser(name.trim(), permissions, email.trim() || undefined);
      if (!user?.api_key) throw new Error('The server did not confirm creation. Check User Management before trying again.');
      setCreated(user); onCreated();
    } catch (error) { setError(error instanceof Error ? error.message : 'Could not create user.'); }
    finally { setBusy(false); }
  };
  return <AdminDialog title="Create User" onClose={() => { if (!busy) onClose(); }}>
    {created ? <><p>User created: <strong>{created.name}</strong></p><p>API key</p><code className="admin-copy">{created.api_key}</code><p>Use Edit User to change pricing or request limits.</p><button className="btn btn-primary" onClick={onClose}>Done</button></> :
      <form onSubmit={submit} className="admin-create-form">
        <label>Name<input required maxLength={100} className="form-input" value={name} onChange={e => setName(e.target.value)} /></label>
        <label>Email (optional)<input type="email" className="form-input" value={email} onChange={e => setEmail(e.target.value)} /></label>
        <fieldset disabled={busy}><legend>Permissions</legend>{['search','metadata','health','export','contacts','suggestions','admin'].map(permission => <label key={permission} className="admin-toggle"><input type="checkbox" checked={permissions.includes(permission)} onChange={e => setPermissions(previous => e.target.checked ? [...previous, permission] : previous.filter(v => v !== permission))} />{permission}</label>)}</fieldset>
        {error && <p role="alert" className="admin-notice admin-notice--error">{error}</p>}
        <button className="btn btn-primary" disabled={busy || !name.trim() || !permissions.length}>{busy ? 'Creating…' : 'Create user'}</button>
      </form>}
  </AdminDialog>;
}
